import { fetchRoamingBundles } from '../../../modules/Dashboard';
import { connect } from 'react-redux';
import { CommonActions } from '@react-navigation/native';
import AddInternationalButton from './AddInternationalButton';
import Navigation from '../../../lib/navigation';

const mapDispatchToProps = dispatch => ({
  goToInternational: () => {
    dispatch(fetchRoamingBundles());
    Navigation.dispatch(CommonActions.navigate({ name: 'international' }));
  },
});

export default connect(null, mapDispatchToProps)(AddInternationalButton);
